import React from "react";
import { useProfileFormHook } from "./profile-form-hooks";

type ContextProfileForm = ReturnType<typeof useProfileFormHook>;
export const ProfileFormContext =
  React.createContext<ContextProfileForm | null>(null);

export function useContextProfileForm() {
  const context = React.useContext(ProfileFormContext);

  if (!context) {
    throw new Error(
      "useContextProfileForm must be used within a ContextProfileFormProvider",
    );
  }

  return context;
}
